var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "my-1", attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex align-items-center justify-content-end" },
              [
                _c(
                  "b-button",
                  {
                    attrs: { variant: "primary", to: "/customer/customer-add" },
                  },
                  [
                    _c("span", { staticClass: "text-nowrap" }, [
                      _vm._v("Add Customer"),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "my-1", attrs: { cols: "12", md: "6" } },
            [
              _c(
                "b-form-group",
                { staticClass: "mb-0", attrs: { label: "Select Columns:" } },
                [
                  _c("b-form-checkbox-group", {
                    attrs: { options: _vm.columnOptions },
                    model: {
                      value: _vm.selectedColumns,
                      callback: function ($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-col",
        { staticClass: "my-1", attrs: { cols: "12", sm: "3" } },
        [
          _c(
            "b-form-group",
            { staticClass: "mb-0" },
            [
              _c(
                "label",
                { staticClass: "d-inline-block text-sm-left mr-50" },
                [_vm._v("Per page")]
              ),
              _c("b-form-select", {
                attrs: {
                  id: "perPageSelect",
                  size: "sm",
                  options: _vm.pageOptions,
                },
                model: {
                  value: _vm.perPage,
                  callback: function ($$v) {
                    _vm.perPage = $$v
                  },
                  expression: "perPage",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("b-col", { staticClass: "my-1", attrs: { cols: "12", sm: "3" } }),
      _c(
        "b-col",
        {
          staticClass: "d-flex justify-content-end mb-2",
          staticStyle: { position: "relative", "z-index": "1" },
          attrs: { cols: "12" },
        },
        [
          _c(
            "b-button",
            {
              attrs: { variant: "outline-danger" },
              on: { click: _vm.clearFilters },
            },
            [_vm._v(" Clear Filters ")]
          ),
        ],
        1
      ),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-table", {
                attrs: {
                  striped: "",
                  hover: "",
                  responsive: "",
                  "per-page": _vm.perPage,
                  "current-page": _vm.currentPage,
                  items: _vm.filteredCustomers,
                  fields: _vm.dynamicFields,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.sortDesc,
                  "sort-direction": _vm.sortDirection,
                },
                on: {
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.sortDesc = $event
                  },
                  filtered: _vm.onFiltered,
                },
                scopedSlots: _vm._u([
                  {
                    key: "head(otherName)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Customer Name")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Customer Name",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.columnFilters.otherName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.columnFilters, "otherName", $$v)
                                },
                                expression: "columnFilters.otherName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(email)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Email")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Email",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.columnFilters.email,
                                callback: function ($$v) {
                                  _vm.$set(_vm.columnFilters, "email", $$v)
                                },
                                expression: "columnFilters.email",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(salesPersonId)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Sales Person")]),
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.salesPersonOptions,
                                placeholder: "Filter by Sales Person",
                                size: "sm",
                              },
                              on: { change: _vm.filterTable },
                              model: {
                                value: _vm.columnFilters.salesPersonId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.columnFilters,
                                    "salesPersonId",
                                    $$v
                                  )
                                },
                                expression: "columnFilters.salesPersonId",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(typeDesc)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Customer Type")]),
                            _c("b-form-select", {
                              attrs: {
                                options: _vm.customerTypeOptions,
                                placeholder: "Filter by Customer Type",
                                size: "sm",
                              },
                              on: { change: _vm.filterTable },
                              model: {
                                value: _vm.columnFilters.typeDesc,
                                callback: function ($$v) {
                                  _vm.$set(_vm.columnFilters, "typeDesc", $$v)
                                },
                                expression: "columnFilters.typeDesc",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(fieldInstruction)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Category")]),
                            _c("b-form-input", {
                              attrs: {
                                placeholder: "Filter by Category",
                                size: "sm",
                              },
                              on: { input: _vm.filterTable },
                              model: {
                                value: _vm.columnFilters.fieldInstruction,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.columnFilters,
                                    "fieldInstruction",
                                    $$v
                                  )
                                },
                                expression: "columnFilters.fieldInstruction",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "head(createdOn)",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex flex-column" },
                          [
                            _c("span", [_vm._v("Created On")]),
                            _c("DatePicker", {
                              staticClass: "small-datepicker",
                              attrs: {
                                range: "",
                                placeholder: "Filter by Date Range",
                                size: "sm",
                                clearable: false,
                                "input-attr": { readonly: true },
                              },
                              on: {
                                change: _vm.filterTable,
                                focus: _vm.openCalendar,
                              },
                              model: {
                                value: _vm.columnFilters.createdOnRange,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.columnFilters,
                                    "createdOnRange",
                                    $$v
                                  )
                                },
                                expression: "columnFilters.createdOnRange",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "cell(companyName)",
                    fn: function (data) {
                      return [
                        data.item.companyName === null
                          ? _c("b-badge", { attrs: { variant: "primary" } }, [
                              _vm._v(" Not a Company "),
                            ])
                          : _vm._e(),
                        _vm._v(" " + _vm._s(data.item.companyName) + " "),
                      ]
                    },
                  },
                  {
                    key: "cell(surname)",
                    fn: function (data) {
                      return [
                        data.item.surname === null
                          ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                              _vm._v(" " + _vm._s(data.item.companyName) + " "),
                            ])
                          : _vm._e(),
                        _vm._v(" " + _vm._s(data.item.surname) + " "),
                      ]
                    },
                  },
                  {
                    key: "cell(otherName)",
                    fn: function (data) {
                      return [
                        data.item.otherName === null
                          ? _c("b-badge", { attrs: { variant: "secondary" } }, [
                              _vm._v(" " + _vm._s(data.item.companyName) + " "),
                            ])
                          : _vm._e(),
                        _vm._v(
                          " " +
                            _vm._s(data.item.otherName) +
                            " " +
                            _vm._s(data.item.surname) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(status)",
                    fn: function (data) {
                      return [
                        data.item.status === 1
                          ? _c("b-badge", { attrs: { variant: "info" } }, [
                              _vm._v(" Booked "),
                            ])
                          : data.item.status === 2
                          ? _c("b-badge", { attrs: { variant: "primary" } }, [
                              _vm._v(" Available "),
                            ])
                          : data.item.status === 3
                          ? _c("b-badge", { attrs: { variant: "warning" } }, [
                              _vm._v(" Maintainace "),
                            ])
                          : data.item.status === 4
                          ? _c("b-badge", { attrs: { variant: "danger" } }, [
                              _vm._v(" Broken "),
                            ])
                          : _c("b-badge", { attrs: { variant: "danger" } }, [
                              _vm._v(" Not Available "),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "cell(salesPersonId)",
                    fn: function (data) {
                      return [
                        data.item.salesPersonId === null
                          ? _c("p", [_vm._v("-")])
                          : _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.getSalePersonName(data.item.salesPersonId)
                                )
                              ),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "cell(createdOn)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formatDate(data.item.createdOn)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "primary",
                              to: _vm.getCustomerData(data.item.id),
                            },
                          },
                          [_c("feather-icon", { attrs: { icon: "EyeIcon" } })],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c(
                "div",
                { staticClass: "d-flex justify-content-center mb-1" },
                [
                  _vm.loading
                    ? _c("b-spinner", {
                        staticStyle: { width: "3rem", height: "3rem" },
                        attrs: {
                          variant: "success",
                          label: "Spinning",
                          block: "",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("b-pagination", {
                staticClass: "my-0",
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.perPage,
                  align: "center",
                  size: "sm",
                },
                model: {
                  value: _vm.currentPage,
                  callback: function ($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage",
                },
              }),
              _c("b-form-group", [
                _vm._v(
                  " Showing " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? _vm.perPage * (_vm.currentPage - 1) + 1
                        : 0
                    ) +
                    " to " +
                    _vm._s(
                      _vm.totalRows > 0
                        ? Math.min(_vm.perPage * _vm.currentPage, _vm.totalRows)
                        : 0
                    ) +
                    " of " +
                    _vm._s(_vm.totalRows > 0 ? _vm.totalRows : 0) +
                    " entries "
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }